import { render, staticRenderFns } from "./icon-rotate-gradient.vue?vue&type=template&id=db6a2fc8&"
import script from "./icon-rotate-gradient.vue?vue&type=script&lang=js&"
export * from "./icon-rotate-gradient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports